import { render, staticRenderFns } from "./AddressIcon.vue?vue&type=template&id=d9fb7ba6&"
import script from "./AddressIcon.vue?vue&type=script&lang=js&"
export * from "./AddressIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports